export default __webpack_public_path__ + "static/media/june2023-4.3b750153.jpg";